module.exports = __webpack_public_path__ + "static/media/couple_summer_2021.20c60dd0.jpeg";